import { useState } from "react";
import { Link, matchPath, useLocation, useNavigate } from "react-router-dom";

/**Import Assets */
import styles from "./styles/ProtectedLayout.module.scss";
// import cssStyles from './styles/notification.module.css';
/**Import Custom Component */
import { BiSolidDollarCircle, BiSupport } from "react-icons/bi";
import { SlBadge } from "react-icons/sl";
import { WEB_ROUTES } from "../../constants";
import { baseRoute } from "../../Helper";
import Navbar from "./Navbar";
// Icons
import { uniqueId } from "lodash";
import { FaUser } from "react-icons/fa";
import { IoIosSettings } from "react-icons/io";
import {
  MdDashboard,
  MdHub,
  MdOutlinePointOfSale,
  MdPolicy,
} from "react-icons/md";
import { removeToken } from "../../Data/services/localStorageService";
import { useLogoutUserMutation } from "../../Data/services/userAuthApi";
import LogoutModal from "../Modals/LogoutModal";

export default function ProtectedLayout({
  isSearchBar,
  isSettingButton,
  selectedRoute,
  children,
}) {
  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);
  const location = useLocation();
  const locationPath = window.location.pathname;
  console.log(locationPath);

  // const chatCount = useSelector((state) => state.chat.count);
  // console.log(chatCount);

  // inject data:
  // useGetCategoryListQuery();

  const [logoutModal, setLogoutModal] = useState(false);

  const isActiveRoute = (route) => {
    const regex = new RegExp(`^${route}`);
    return regex.test(location.pathname);
  };

  const navigate = useNavigate();
  // todo: menu
  const items = [
    {
      label: "Dashboard",
      icon: <MdDashboard />,
      route: WEB_ROUTES.DASHBOARD,
      // lineBreak: true,
    },
    {
      label: "Financial Management",
      icon: <BiSolidDollarCircle />,
      route: WEB_ROUTES.FINANCIAL_MANAGEMENT,
    },
    {
      label: "Sales Management",
      icon: <MdOutlinePointOfSale />,
      route: WEB_ROUTES.SALES_MANAGEMENT,
      // lineBreak: true,
    },
    {
      label: "User Management",
      icon: <FaUser />,
      route: WEB_ROUTES.USER_MANAGEMENT,
    },
    {
      label: "Content Management",
      icon: <MdPolicy />,
      route: WEB_ROUTES.PAGE_MANAGEMENT,
      // lineBreak: true,
    },

    {
      label: "Customer Service",
      icon: <BiSupport />,
      route: WEB_ROUTES.CUSTOMER_SERVICE,
    },
    {
      label: "Agreements Hub",
      icon: <MdHub />,
      route: WEB_ROUTES.AGREEMENT_HUB,
    },
    // {
    //   label: "Poll Rules Management",
    //   icon: <LiaPollHSolid />,
    //   route: WEB_ROUTES.POLL_RULES_MANAGEMENT,
    //   lineBreak: true,
    // },
    // {
    //   label: "Polls Management",
    //   icon: <FaPollH />,
    //   route: WEB_ROUTES.POLLS_MANAGEMENT,
    //   // lineBreak: true,
    // },
    // {
    //   label: "Suggested Polls",
    //   icon: <RiChatPollLine />,
    //   route: WEB_ROUTES.SUGGESTION_POLLS_MANAGEMENT,
    //   lineBreak: true,
    // },
    // {
    //   label: "Transaction Management",
    //   icon: <TbTransactionDollar />,
    //   route: WEB_ROUTES.TXN_MANAGEMENT,
    //   // lineBreak: true,
    // // },
    // {
    //   label: (
    //     <span className="d-flex gap-3">
    //       Chat Support
    //       {/* {chatCount > 0 && (
    //         <Badge pill bg="danger" className="p-2">
    //           {chatCount}
    //         </Badge>
    //       )} */}
    //     </span>
    //   ),
    //   icon: <GrChat />,
    //   route: WEB_ROUTES.SUPPORT,
    //   lineBreak: true,
    // },
    // {
    //   label: "Send Notification",
    //   icon: <IoNotifications />,
    //   route: WEB_ROUTES.SEND_NOTIFICATION,
    // },

    {
      label: "Settings",
      icon: <IoIosSettings />,
      route: WEB_ROUTES.SETTING,
    },
  ];

  const handleSettings = () => {
    navigate(WEB_ROUTES.SETTING);
  };

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  const handleViewProfile = () => {
    navigate(baseRoute(WEB_ROUTES.PROFILE));
  };

  const handleLogoutModalOpen = () => {
    setLogoutModal(true);
  };

  const handleLogoutModalClose = () => {
    setLogoutModal(false);
  };

  const [logoutUser, { isLoading }] = useLogoutUserMutation();

  const handleLogout = async () => {
    removeToken();
    navigate("/account");
    return;
    // try {
    //   const response = await logoutUser().unwrap();
    //   if (response.code === 200) {
    //     removeToken();
    //     navigate("/account");
    //     window.location.reload();
    //     Toast("Logged Out Successfully", "success");
    //   }
    // } catch {
    //   Toast("An error occurred during log out", "error");
    // }
  };

  return (
    <div className={styles.ProtectedLayout}>
      <div
        className={collapsed ? styles.background : ""}
        onClick={handleMenuClose}
      ></div>
      <div
        className={`${styles.menu} ${
          collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
        }`}
        id="sider"
      >
        <div
          className={`${styles.logo} ${
            !collapsed ? styles.notCollapsed : ""
          } rounded-circle`}
          to={`${process.env.REACT_APP_DOMAIN_DIR}/dashboard`}
        >
          <img
            src={collapsed ? "/images/logo_name.png" : "/images/small_logo.png"} //todo:
            alt="Logo"
            className={`${
              collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
            } image-fluid object-fit-contain`}
            width={"100%"}
            height={"100%"}
          />
        </div>
        {/* <div className={`${styles.drawer} ${collapsed ? styles.collapsed : ''}`}>

                    <span onClick={handleToggle}>
                        <BiLogOut />
                    </span>
                </div> */}
        {items.map(({ icon, label, route, lineBreak }, index) => {
          // console.log(label);
          // let LowerCaseLabel = label.toLowerCase().replace(/[^A-Z0-9]/gi, "-");
          return (
            <div key={uniqueId()}>
              <Link
                to={route}
                className={`${styles.item} ${
                  isActiveRoute(route) ? styles.active : ""
                } ${!collapsed ? styles.collapsed : ""}`}
                key={uniqueId()}
              >
                <span style={{ fontSize: "20px", display: "flex" }}>
                  {icon}
                </span>
                {collapsed ? <p>{label}</p> : ""}
              </Link>
              {lineBreak ? (
                <hr key={uniqueId()} className="w-100 m-0 "></hr>
              ) : null}
            </div>
          );
        })}
        {/* <Link
          className={styles.item}
          onClick={handleLogoutModalOpen} */}
        {/* // onClick=
        {() =>
          submit("Confirm Logout", "Are you sure you want to logout?", () =>
            handleLogout()
          )
        } */}
        {/* > */}
        {/* <img src={logout} alt="Icon1" width={20} height={20} /> */}
        {/* <span style={{ fontSize: "20px", display: "flex" }}>
            <TbLogout2 />
          </span>
          {collapsed ? <p>Logout</p> : ""}
        </Link> */}
      </div>
      <div className={styles.routeContent}>
        {logoutModal ? (
          <LogoutModal
            handleLogoutModalClose={handleLogoutModalClose}
            data={""}
            loading={isLoading}
            onLogout={handleLogout}
          />
        ) : null}
        <Navbar
          isSearchBar={isSearchBar}
          isSettingButton={isSettingButton}
          handleToggle={handleToggle}
          handleLogoutModalOpen={handleLogoutModalOpen}
          handleSettings={handleSettings}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
